import {
    compose
} from 'underscore';
import {
    Config,
    Enums
} from './Config/Config';
import Store from './Store/Store';
import {EventBus} from './EventBus';

export default class LayerManager {
    constructor(_map) {
        this._map = _map;
    }
    //https://docs.mapbox.com/mapbox-gl-js/example/variable-label-placement/
    UpdateLabelVisibility() {
        const self = this;
        let map = this._map.map;
        if (
            map.getSource(`fips-labels-${self._map.districtType}-source`) &&
            map.isSourceLoaded(`fips-labels-${self._map.districtType}-source`) &&
            typeof map.getLayer(`fips-labels-${self._map.districtType}`) !==
            "undefined"
        ) {
            //If everything is loaded already, go for it: change the visibility
            Config.layersConfig.labelLayerArray.forEach(layer => {
                if (layer.id.includes(self._map.districtType)) {
                    map.setLayoutProperty(layer.id, "visibility", "visible");
                } else {
                    map.setLayoutProperty(layer.id, "visibility", "none");
                }
            });
        } else {
            //Otherwise attach an event handler to the sourcedata event to make the changes after things are loaded
            self._map.map.on("sourcedata", this.setLabels);
        }
    }
    //The event handler for when source data is loaded
    setLabels(e) {

        const self = this;
        const districtType = Store.getters.getDistrictType;
        if (
            this.getSource(`fips-labels-${districtType}-source`) &&
            this.isSourceLoaded(`fips-labels-${districtType}-source`) &&
            typeof this.getLayer(`fips-labels-${districtType}`) !==
            "undefined"
        ) {
            Config.layersConfig.labelLayerArray.forEach(layer => {
                if (layer.id.includes(districtType)) {
                    // console.log(layer.id+ ' visible')
                    self.setLayoutProperty(layer.id, "visibility", "visible");
                } else {
                    self.setLayoutProperty(layer.id, "visibility", "none");
                }
            });
        }
        self.off("sourcedata", this.setLabels); //Remove the handler!
    }

    addCustomLayers() {
        let map = this._map.map;
        const layers = Config.layersConfig.layerArray;
        const existingLayers = map.getStyle().layers.map(l => l.id);

        for (let l = 0; l < layers.length; l++) {
            if (!map.getLayer(layers[l].id)) {
                if (existingLayers.indexOf(layers[l].params.beforeId) > -1) {
                    map.addLayer(layers[l], layers[l].params.beforeId);
                } else {
                    console.warn(`didn't find before layer for ${layers[l].id}`)
                    map.addLayer(layers[l]);
                }

            }
        }

        Config.layersConfig.choroplethLayerArray.forEach((l, idx) => {
            this._map.mapMethods.setChoroplethStyle(l.id);
        })
    }
    //Same idea as labels. Do everything if it's ready. Otherwise attach an event handler
    UpdateChoroplethLayerVisibility(val) {
        const self = this;
        const districtType = Store.getters.getDistrictType;
        const selectedDistrict = Store.getters.getDistrictFIPS;
        //console.log(Store.getters.getgeoTypeVisible)
        if (Store.getters.getgeoTypeVisible === 'tracts' || Store.getters.getgeoTypeVisible === 'voting-precincts') {

            this.SetChoroplethFillVisibility(districtType, false);
        } else {
            this.SetChoroplethFillVisibility(districtType, true);
        }

        this.SetChoroplethOutlineVisiblity(districtType)

    }

    SetChoroplethFillVisibility(val, toVisible) {
        const self = this;
        const districtType = Store.getters.getDistrictType;
        const selectedDistrict = Store.getters.getDistrictFIPS;

        if (toVisible) {
            Config.layersConfig.choroplethLayerArray.forEach((layer) => {

                if (layer.id === val) {
                    self._map.map.setLayoutProperty(layer.id, "visibility", "visible");
                } else {
                    if (layer.layout && !layer.id.includes('tract') && !layer.id.includes('voting-precincts') && !layer.id.includes('outline') && !layer.id.includes('voting')) {
                        self._map.map.setLayoutProperty(layer.id, "visibility", "none");
                    }
                }
            });
        } else {
            Config.layersConfig.choroplethLayerArray.forEach((layer) => {
                if (!layer.id.includes('tract') && !layer.id.includes('outline') && !layer.id.includes('voting-precincts')) {
                    self._map.map.setLayoutProperty(layer.id, "visibility", "none");

                }

            });
        }

    }

    SetChoroplethOutlineVisiblity(val) {
        const self = this;
        const districtType = Store.getters.getDistrictType;
        const selectedDistrict = Store.getters.getDistrictFIPS;


        Config.layersConfig.choroplethLayerArray.forEach((layer) => {
            if (layer.id.includes(val) && (layer.id.includes('outline') ||
                    layer.id.includes('highlight'))) {
                //console.log(layer.id + 'visible')
                self._map.map.setLayoutProperty(layer.id, "visibility", "visible");
            } else {
                if ((layer.layout && !layer.id.includes('tract') && !layer.id.includes('voting-precincts')) && layer.id !== districtType) {
                    //.log(layer.id + ' hidden')
                    self._map.map.setLayoutProperty(layer.id, "visibility", "none");
                }
            }
        });

    }


    //Turn on tract layer, turn off choropleth fill, keep on choropleth outline for district type
    //OR turn off all layers except active district type fill and outline
    SetChoroLayerVisibility(toVisible, choroLayerId = 'tract-cvap') {

        Config.layersConfig.choroplethLayerArray.forEach((layer) => {
            if (toVisible) {
                if (layer.id === choroLayerId) {
                    this._map.map.setLayoutProperty(layer.id, "visibility", "visible");
                } else {
                    if (layer.id.includes('outline') && layer.id.includes(Store.getters.getDistrictType)) {
                        this._map.map.setLayoutProperty(layer.id, "visibility", "visible");
                    } else {
                        this._map.map.setLayoutProperty(layer.id, "visibility", "none");
                    }

                }
            } else {
                if (layer.id.includes(Store.getters.getDistrictType)) {
                    this._map.map.setLayoutProperty(layer.id, "visibility", "visible");
                } else {
                    this._map.map.setLayoutProperty(layer.id, "visibility", "none");
                }
            }

        });
        let geoTypeVisible = 'jurisdiction';
        if (toVisible) {
            geoTypeVisible = choroLayerId.includes('tract') ? 'tracts' : 'voting-precincts';

        }
        //console.log(geoTypeVisible)
        // if(){
        if (choroLayerId === 'tract-vap') {
            
            EventBus.updateQueryObj(['tractVAPLayer', 'true']);
            EventBus.updateQueryObj(['tractLayer', -1]);
        } else {
            EventBus.updateQueryObj(['tractVAPLayer', -1]);
        }
        
        const isVap = (choroLayerId === 'tract-vap');
        //console.log(isVap)
        //}console
        Store.commit("setgeoTypeVisible", {val:geoTypeVisible, isVap})
    }

    SetCountyLayerVisibility(toVisible) {
        const CountyLayerIds = ['county-outline', 'county-outline-labels'];
        CountyLayerIds.forEach((id) => {
            this._map.map.setLayoutProperty(id, "visibility", toVisible ? "visible" : "none");
        })

    }

    SetChoroplethOpacity(val) {
        const self = this;
        const zoom = self._map.map.getZoom();
        const maxWide = Config.layersConfig.maxWide;
        const minClose = Config.layersConfig.minClose;

        const mixOpacity = .8; //(zoom < maxWide && zoom > minClose) ? .8 : 1;
        if (self._map.map.isStyleLoaded()) {
            Config.layersConfig.choroplethLayerArray.forEach((layer) => {
                if (layer.paint['fill-opacity']) {
                    self._map.map.setPaintProperty(layer.id, "fill-opacity", +val * mixOpacity, {
                        validate: false
                    });
                }
            });
        }
    }

    ClearOldHighlight(_districtType) {

        this._map.map.setFilter(`${_districtType}-highlight-outline`, [
            "==",
            ["get", "geoid"],
            "-1",
        ]);

    }

    ClearAllHighlights() {
        Object.keys(Enums.LEG_BODY).forEach((b) => {
            this.ClearOldHighlight(Enums.LEG_BODY[b]);
        })
    }

    //Depricated but may be useful if we need geojson data later
    async updateBoundedLayers() {
        let layers = Config.layersConfig.layerArray.filter(l => l.bounded);

        for (let l = 0; l < layers.length; l++) {
            const dataUrl = layers[l].sourceDataURL.replace('%%BBOX%%', Store.getters.getMapBoundsString);
            const resp = await fetch(dataUrl);
            const data = await resp.json();

            this._map.map.getSource(layers[l].id).setData(data);
        }

    }

    GetColor(val, scale, belowThreshold = false) {
        //TODO: If pop is less than threshold then return clear
        if (belowThreshold) return 'rgba(0,0,0,0)';

        for (let s = 0; s < scale.length; s++) {
            if (scale[s].step.length === 2) {
                if (s === 0) {
                    if (
                        (scale[s].step[1] === false && +val < +scale[s].step[0]) || (scale[s].step[1] === true && +val <= +scale[s].step[0])) {
                        return scale[s].color;
                    }

                } else {
                    if (
                        (scale[s].step[1] === false && +val > +scale[s].step[0]) || (scale[s].step[1] === true && +val >= +scale[s].step[0])) {
                        return scale[s].color;
                    }
                }

            } else if (this.isBetween(val, scale[s].step)) {
                return scale[s].color;
            }
        }

        return 'rgba(0,0,0,0)'
    }

    isBetween(_val, step) {
        const a = step[0];
        const b = step[2];
        const minInclusive = step[1];
        const maxInclusive = step[3];

        var min = Math.min.apply(Math, [a, b]),
            max = Math.max.apply(Math, [a, b]);

        const aReq = minInclusive ? _val >= min : _val > min;
        const bReq = maxInclusive ? _val <= max : _val < max;

        return (aReq && bReq);
    }

}